import React from 'react';

import { SafeHtml } from '@bcp-channels-sharedcomponents-reactjs/core';
import {
	BaseModal,
	Box,
	Button,
	CSSProperties,
	Image,
	Link,
	Overlay,
	Typography,
} from '@bcp-nextgen-dx-component-factory/design-system';
import { NavClose } from '@bcp-nextgen-dx-component-factory/icons-accolade';
import { Call, NavRight } from '@bcp-nextgen-dx-component-factory/icons-accolade';
import { useTheme } from '@themes';

import { useAutoSimulation } from './autoSimulate.helper';

// eslint-disable-next-line sonarjs/cognitive-complexity
export const AutoSimulateModalBcp: React.FC = () => {
	const {
		currentView,
		handleClickContinueApp,
		handleClickContinueToSite,
		handleOnClickRequestContact,
		handleOnClickClose,
		isVisible,
		qrCodeToApp,
		translate,
	} = useAutoSimulation();
	const { images } = useTheme();

	const simulateStyles = {
		smallView: {
			modalConfig: {
				top: '50%',
				left: '50%',
				maxHeight: '90vh',
				transform: 'translate(-50%, -50%)',
				position: 'fixed',
				padding: undefined,
				height: undefined,
				width: 'calc(100vw - 32px)',
				flexDirection: 'column',
			},
			contentConfig: {
				padding: '32px',
				marginLeft: undefined,
			},
			imageBoxConfig: {
				alignSelf: 'end',
				maxWidth: '227px',
			},
			imageConfig: {
				width: '100%',
				height: '227px',
			},
			titleBoxConfig: {
				marginTop: '12px',
				textAlign: 'center',
				flexDirection: 'column',
			},
			logoBoxConfig: {},
			qrCodeImage: {},
		},
		tabletView: {
			modalConfig: {
				height: '311px',
				width: '536px',
				padding: '32px 32px 24px 32px',
				flexDirection: 'row',
			},
			contentConfig: {
				marginLeft: '8px',
				maxWidth: '42%',
			},
			imageBoxConfig: {
				alignSelf: 'end',
			},
			imageConfig: {
				width: '242px',
				height: '100%',
			},
			titleBoxConfig: {
				marginTop: '22px',
			},
			logoBoxConfig: {
				marginTop: '22px',
			},
			qrCodeImage: {},
		},
		bigView: {
			modalConfig: {
				height: undefined,
				width: '632px',
				padding: '32px 40px 56px',
				flexDirection: 'row',
			},
			contentConfig: {
				marginLeft: '8px',
				minWidth: '276px',
			},
			imageBoxConfig: {
				alignSelf: 'end',
			},
			imageConfig: {},
			titleBoxConfig: {
				marginTop: '32px',
			},
			logoBoxConfig: {
				marginTop: '22px',
			},
			qrCodeImage: {
				width: '150px',
				height: '150px',
				marginLeft: '-3px',
			},
		},
	};

	return (
		<BaseModal visible={isVisible} externalBackdrop={<Overlay onPress={handleOnClickClose} />}>
			<Box
				styles={{
					background: '#FFFFFF',
					borderRadius: '24px',
					flexDirection: 'column',
				}}
			>
				<Box
					styles={{
						background: '#FFFFFF',
						borderRadius: '24px',
						...(simulateStyles[currentView].modalConfig as CSSProperties),
					}}
				>
					<Box
						styles={{
							alignItems: 'center',
							flexDirection: 'column',
							flex: 1,
							...simulateStyles[currentView].contentConfig,
						}}
					>
						{currentView === 'smallView' && (
							<>
								<Box onPress={handleOnClickClose} styles={{ zIndex: 3, alignSelf: 'end' }}>
									<Image
										source={NavClose.Outline}
										svgProps={{
											fill: '#6A717C',
											width: '24px',
											height: '24px',
										}}
									/>
								</Box>
								<Box styles={{ width: '100%', justifyContent: 'center' }}>
									<Box styles={{ alignSelf: 'start', marginLeft: '8px' }}>
										<Image source={images.mbcpLogo.src} />
									</Box>
									<Box
										styles={{
											alignItems: 'center',
											flexDirection: 'column',
											flex: 1,
											...simulateStyles[currentView].imageBoxConfig,
										}}
									>
										{/* cSpell: disable */}
										{/* <Image
												svgProps={{ ...simulateStyles[currentView].imageConfig }}
												source={
													BaseSessionInfoLoanType.AL === creditType
														? sessionInfo.language === BaseSessionInfoLanguage.EN
															? images.autoModalMobileEn.src
															: images.autoModalMobilePt.src
														: BaseSessionInfoLoanType.CL === creditType
														? sessionInfo.language === BaseSessionInfoLanguage.EN
															? images.personalModalEn.src
															: images.personalModalPt.src
														: sessionInfo.language === BaseSessionInfoLanguage.EN
														? images.renenModalMobileEn.src
														: images.renenModalMobilePt.src
												}
											/> */}
										<Image
											svgProps={{ ...simulateStyles[currentView].imageConfig }}
											source={translate('simulator.modals.autoSimulate.genericModalMobile')}
										/>
										{/* cSpell: enable */}
									</Box>
								</Box>
							</>
						)}
						{currentView === 'tabletView' && (
							<Box styles={{ alignSelf: 'start', ...simulateStyles[currentView].logoBoxConfig }}>
								<Image source={images.mbcpLogo.src} />
							</Box>
						)}
						<Box styles={{ ...(simulateStyles[currentView].titleBoxConfig as CSSProperties) }}>
							{/* {BaseSessionInfoLoanType.CL === creditType ? ( */}
							<Typography appearance="subtitle-100-02">
								<SafeHtml html={translate('simulator.modals.autoSimulate.completeYourLoanInTheApp')} />
							</Typography>
							{/* ) : (
								<Typography appearance="subtitle-100-02">
							
									{BaseSessionInfoLoanType.AL === creditType
										? translate('simulator.modals.autoSimulate.onlineUsedCardLoanIsExclusive')
										: translate(
												'simulator.modals.autoSimulate.onlineRenewableEnergyLoanIsExclusive'
										  )}{' '}
									<Typography appearance="subtitle-100-04">
										{translate('simulator.modals.autoSimulate.exclusiveToTheMillenniumApp')}
									</Typography>
							
								</Typography>
							)} */}
						</Box>
						{currentView === 'bigView' && (
							<>
								<Box
									styles={{
										marginTop: '16px',
										alignSelf: 'start',
										flexDirection: 'column',
										rowGap: '20px',
									}}
								>
									<Typography appearance="body-100-02">
										<SafeHtml
											html={translate('simulator.modals.autoSimulate.readQRCodeToInstallTheApp')}
										/>
									</Typography>

									<Box>
										<Image
											styles={simulateStyles[currentView].qrCodeImage}
											source={`data:image/jpeg;base64, ${qrCodeToApp}`}
											alt="qr-code"
										/>
									</Box>
								</Box>
							</>
						)}
					</Box>
					{currentView === 'smallView' && (
						<Box styles={{ paddingBottom: '32px', flexDirection: 'column' }}>
							<Box styles={{ alignSelf: 'center', width: '80%' }}>
								<Button
									onPress={handleClickContinueApp}
									size={'xLarge'}
									fullWidth
									children={translate('simulator.modals.autoSimulate.continueOnTheApp')}
								/>
							</Box>
							<Box styles={{ marginTop: '34px', alignSelf: 'center', marginBottom: '32px' }}>
								<Link
									onPress={handleClickContinueToSite}
									variant="light"
									appearance="primary"
									size="large"
									middleContent={translate('simulator.modals.autoSimulate.continueSiteCL')}
									web={{
										target: '_blank',
									}}
								/>
							</Box>
							<Box
								styles={{
									background: '#F3F4F6',
									marginBottom: '-32px',
									borderRadius: '0 0 24px 24px',
									textAlign: 'center',
									padding: '24px 48px 24px',
									gap: '8px',
									flexDirection: 'column',
									alignItems: 'center',
								}}
							>
								<Typography appearance="body-100-02">
									<SafeHtml html={translate('simulator.modals.autoSimulate.requestContact.title')} />
								</Typography>
								<Link
									onPress={handleOnClickRequestContact}
									variant="light"
									appearance="primary"
									size="large"
									middleContent={translate('simulator.modals.autoSimulate.requestContact')}
									startContent={Call.Outline}
									endContent={NavRight.Outline}
									web={{
										target: '_blank',
									}}
								/>
							</Box>
						</Box>
					)}
					{currentView !== 'smallView' && (
						<>
							<Box
								styles={{
									alignItems: 'center',
									flexDirection: 'column',
									flex: 1,
									alignSelf: 'center',
									marginLeft: currentView === 'bigView' ? '-85px' : undefined,
									marginTop: currentView === 'bigView' ? '0px' : '60px',
									marginRight: currentView === 'tabletView' ? '-20px' : undefined,
								}}
							>
								{/* cSpell: disable */}
								{/* <Image
										svgProps={{ ...simulateStyles[currentView].imageConfig }}
										source={
											BaseSessionInfoLoanType.AL === creditType
												? sessionInfo.language === BaseSessionInfoLanguage.EN
													? currentView === 'bigView'
														? images.autoModalEn.src
														: images.autoModalMobileEn.src
													: currentView === 'bigView'
													? images.autoModalPt.src
													: images.autoModalMobilePt.src
												: BaseSessionInfoLoanType.CL === creditType
												? sessionInfo.language === BaseSessionInfoLanguage.EN
													? images.personalModalEn.src
													: images.personalModalPt.src
												: sessionInfo.language === BaseSessionInfoLanguage.EN
												? currentView === 'bigView'
													? images.renenModalEn.src
													: images.renenModalMobileEn.src
												: currentView === 'bigView'
												? images.renenModalPt.src
												: images.renenModalMobilePt.src
										}
									/> */}
								<Image
									svgProps={{ ...simulateStyles[currentView].imageConfig }}
									source={
										currentView === 'bigView'
											? translate('simulator.modals.autoSimulate.genericModalDesktop')
											: translate('simulator.modals.autoSimulate.genericModalMobile')
									}
								/>
								{/* cSpell: enable */}
							</Box>
							<Box
								onPress={handleOnClickClose}
								styles={{ marginLeft: currentView === 'bigView' ? '-50px' : '-16px', zIndex: 3 }}
							>
								<Image
									source={NavClose.Outline}
									svgProps={{
										fill: '#6A717C',
										width: '24px',
										height: '24px',
									}}
								/>
							</Box>
						</>
					)}
				</Box>
				{currentView === 'tabletView' && (
					<Box styles={{ paddingBottom: '32px', flexDirection: 'row', gap: '48px', alignSelf: 'center' }}>
						<Box styles={{ marginTop: '34px', alignSelf: 'center', marginBottom: '18px' }}>
							{/* cSpell: disable */}
							<Link
								onPress={handleClickContinueToSite}
								variant="light"
								appearance="primary"
								size="large"
								middleContent={
									// BaseSessionInfoLoanType.CL === creditType
									translate('simulator.modals.autoSimulate.continueSiteCL')
									// : translate('simulator.modals.autoSimulate.dontHaveApp')
								}
								web={{
									target: '_blank',
								}}
							/>
							{/* cSpell: enable */}
						</Box>
						<Box styles={{ alignSelf: 'self-end' }}>
							{/* cSpell: disable */}
							<Button
								onPress={handleClickContinueApp}
								size={'xLarge'}
								children={translate('simulator.modals.autoSimulate.continueOnTheApp')}
							/>
							{/* cSpell: enable */}
						</Box>
					</Box>
				)}
			</Box>
		</BaseModal>
	);
};
